import { render, staticRenderFns } from "./store-area-form.vue?vue&type=template&id=51ca831d"
import script from "./store-area-form.vue?vue&type=script&lang=js"
export * from "./store-area-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports